<template>
	<!-- 图片选择 -->
	<div @click="setEditIndex(index)">
		<span v-if="isBankViewTest" class="my-bank-tag">图片选择</span>
		<el-row :gutter="10" class="question-box">
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
				{{ question.quesIndex + 1 }}
			</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
				
        		<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
          			:isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<template>
					<el-dropdown v-if="!$route.query.bankId" @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
						<span class="el-dropdown-link">
							<el-tooltip content="收藏到题库" placement="top" effect="light">
                <i v-if="question.isedit && !question.bqid"  class="el-icon-star-off to-bank item"></i>
							</el-tooltip>
						</span>
						<el-dropdown-menu slot="dropdown">
							<div class="scroll-body" style="overflow-y: auto;" :style="{maxHeight: isAddBank ? '102px' : '200px'}">
							<el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
								<span>{{item.name}}</span>
								<el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
							</el-dropdown-item>
							<el-dropdown-item 
								disabled
								style="
								font-size: 12px;
								color: #ccc"
								class="dropdown-item" 
								v-if="bankList.length == 0">
								<span>暂无题库</span>
							</el-dropdown-item>
							</div>

							<el-dropdown-item v-if="isAddBank" divided style="text-align:center">
							<el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
								<el-form-item
								prop="name"
								:rules="[
									{ required: true, message: '不能为空'},
								]"
								>
								<el-input size="mini" v-model="bankForm.name"></el-input>
								</el-form-item>
								<el-form-item  size="mini" style="text-align: right;margin-bottom: 0;">
								<el-button type="text" @click="addBank">创建</el-button>
								<el-button  type="text" @click="cancelAddBank">取消</el-button>
								</el-form-item>
							</el-form>
							</el-dropdown-item>
							
							<el-dropdown-item divided style="text-align:center">
							<el-button  @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tooltip content="取消收藏" placement="top" effect="light">
						<i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid"  @click="delFormBank"></i>
					</el-tooltip>
				</template>
				<template v-if="!isBankViewTest">
					<div @click="() => $emit('jumpshow', question)">
						<el-badge 
							v-if="question.logicalSettings.num" 
							:value="question.logicalSettings.num" 
							class="item">
							<i class="el-icon-share"  ></i>
						</el-badge>
					</div>
					<i  class="el-icon-rank item drag-handle"></i>
					<i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyClick(question)"></i>
					<i class="el-icon-delete delete" v-if="question.isedit" @click="questiondel(question.qid)"></i>
				</template>
			</el-col>
		</el-row>
		<div style="margin-left:47px" class="option-box">
			<div class="upload_box" v-if="!isBankViewTest">
				<div class="upload_box_i">
					<el-upload
						class="avatar-uploader"
						:action="$config.service.uploadApi"
						accept="image/jpeg,image/png"
						:show-file-list="false"
						:on-success="handleSuccess"
						:before-upload="beforeAvatarUpload"
						:data="QiniuData"
						:on-remove="handleRemove"
						multiple
						:limit="limit"
					>
						<i class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<p class="first">当次上传1张</p>
					<p class="first">最多可上传10张</p>
				</div>
			</div>
			<draggable class="drag-container" v-model="question.optionList">
      			<transition-group class="img-box" tag="div" type="transition" :name="'flip-list'">
					<template
						style="margin-top: 12px !important;margin-bottom:20px;margin-right:10px;width:146px;"
						v-for="(childItem, childindex) in question.optionList"
					>
						<div
							class="option-item"
							:key="index + '_' + childindex" 
							@click="setEditOptionIndex(childindex)" 
							style="width:146px;"
						>
							<div class="img_box">
								<img :src="childItem.optionImgUrl" alt="" />
								<div class="radio-optino" v-if="question.cutType == 7">
									<div class="radio"></div>
									<template>
										<span v-if="isBankViewTest">{{childItem.labelName}}</span>
										<TitleEditor 
											v-if="!isBankViewTest" 
											class="outline-none" 
											:qid="childItem.oid" 
											:class="childItem.oid"  
											:value="childItem.labelName" 
											@childValueChange="(val) => labelNameChange(val, childItem)" 
										></TitleEditor>
									</template>
								</div>
								<el-checkbox label="1" style="margin-left:15px;margin-top:10px;" v-if="question.cutType == 8">
									<span v-if="isBankViewTest">{{childItem.labelName}}</span>
									<TitleEditor 
										v-if="!isBankViewTest" 
										class="outline-none" 
										:qid="childItem.oid" 
										:class="childItem.oid"  
										:value="childItem.labelName" 
										@childValueChange="(val) => labelNameChange(val, childItem)" 
									></TitleEditor>
								</el-checkbox>
								<div class="edit">
									<!-- <p> -->
										<p id="uploadImg">
											<input type="file" id="file" size="1" accept="image/*" @change="filechange($event, childItem.oid)" />
											<a href="#">修改</a>
										</p>
									<!-- </p> -->
									<p class="deleteBtn" @click="wjdelquestionoption(childItem.oid, childindex)">删除</p>
								</div>
							</div>
						</div>
					</template>
				 </transition-group>
    		</draggable>
			
			
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import { v1 as UUID } from "uuid";
// import DragMixin from "./DragMixin";
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import { mapState } from "vuex"
export default {
	components: {
    	TitleEditor
	},
	// inject: ['reload'],
 	//  mixins:[DragMixin],
	data() {
		return {
			limit: 10,
			editOptionIndex: '0_0',
			dialogImageUrl: '',
			dialogVisible: false,
			radio: '1',
			QiniuData: {
				biz: 'upDataWj',
				data: {}
			},
			uploadPicUrl: '', //提交到后台图片地址
			fileList: [],
			ImgList: [],
			radioValue: '',
			checkboxValue: [],
			// 题库start
			isAddBank: false,
			bankForm: {
				isSystemBank: 0, // 我的题库
				name: '',
				type: '未分类',
				bankType: 1
			}
			// 题库end	
		};
	},
	props: {
		question: {},
		editIndex: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
		bankList: {
			type: Array,
			default: () => {
			return []
			}
		},
	},
	computed: {
        ...mapState(['headers']),
	},
	watch: {
		'question.questionsName':{
			handler(newV, oldV){
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = ''
				}
			},
			deep: true
		},
    	'question.optionList.length':{
			handler(newV, oldV){
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = ''
				}
			},
			deep: true
		}
	},
	created() {
	},
	methods: {
		copyClick(question){
			this.$emit('questionCopy',question)
		},
		labelNameChange(val, option) {
			if (val !== option.labelName && this.question.bqid) {
				this.question.bqid = ''
			}
			option.labelName = val
		},
		// 题库start
		getBankList(e) {
			if (e) {
				this.$emit('getBankList')
			}
		},
		addToBank(id) {
			this.$refs.bankDropdown.hide()
			this.$emit('addToBank', this.question, id)
			// console.log(this.question)
		},
		cancelAddBank() {
			this.isAddBank = false
			this.bankForm.name = ''
		},
		addBank() {
			this.$refs.ValidateForm.validate((valid) => {
				if (valid) {
					this.isAddBank = true
					this.$emit('addBank', this.bankForm, this.question.qid)
				} else {
					console.log('验证失败');
					return false;
				}
				});
			// this.$refs.bankDropdown.show()
		},
		delFormBank() {
			this.$emit('delFormBank', this.question)
		},
		// 题库end
		filechange(item, id) {
			var formData = new FormData();
			formData.append('file', item.target.files[0])
			formData.append('biz', 'upDataWj')
			var thit = this;
			$.ajax({
				url: `${this.$config.service.uploadApi}`,
				type: 'POST',
				data: formData,
				miniType: 'multipart/form-data',
				/**
				 *必须false才会自动加上正确的Content-Type
				 */
				contentType: false,
				/**
				 * 必须false才会避开jQuery对 formdata 的默认处理
				 * XMLHttpRequest会对 formdata 进行正确的处理
				 */
				processData: false,
				success: function(data) {
					// console.log('上传成功：文件访问地址：');
					// console.log(data)
					thit.xiugai(id, data.message);
				},
				error: function() {
					alert('上传失败！');
				}
			});
		},
		xiugai(id, imgUrl) {
			if (this.question != null && this.question.optionList.length > 0) {
				this.question.optionList.forEach((info,i) => {
					if (info.oid == id) {
						info.optionImgUrl = imgUrl
						info.labelName = imgUrl.split('upDataWj/')[1]
					}
				})
			}
			// console.log(this.question.optionList)
		},
		handleSuccess(res, file, fileList) {
			this.question.optionList.push(
				{
					labelName: file.name,
					optionImgUrl: file.response.message,
					oid: UUID()
				}
			)
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		wjupdoption(item) {
			this.$emit('wjupdoption', item);
		},
		wjaddquestionoption(optionList, item, type = 1) {
			this.$emit('wjaddquestionoption', optionList, item, type);
		},
		setEditIndex(index) {
			// console.log(index)
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		wjdelquestionoption(oid, index) {
      		this.$emit("wjdelquestionoption", { qid: this.question.qid, oid }, index,)
		},
		questiondel(id) {
			this.$emit('questiondel', id);
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		handleExceed() {
			this.$message.warning(`当前限制选择 3 张图片，如需更换，请删除上一张图片在重新选择！`);
		},
		beforeAvatarUpload(file) {
			this.QiniuData.data = file
			// this.QiniuData.key = `${file.name}`;
			// console.log(this.QiniuData)
		}
	}
};
</script>

<style scoped lang="scss">
/deep/.img_box .el-input__inner {
	width: 100px !important;
}
.img_box {
	width: 146px;
	min-height: 220px;
	border: 1px solid #ccc;
	position: relative;
}
.img_box img {
	width: 146px;
	height: 146px;
}
.img_box:hover .edit {
	display: flex;
	width: 100%;
}
.edit {
	position: absolute;
	display: none;
	left: 0;
	bottom: 0;
	padding-bottom: 5px;
	background-color: rgba(204,204,204,.9);
	p{
		margin-top: 7px !important;
		color: #666;
		width: 73px;
		font-size: 12px;
		// float: left;
		text-align: center;
		a{
			color: #666;
		}
	}
}
#uploadImg {
	font-size: 12px;
	input{
		cursor: pointer;
		width: 24px;
		height: 16px;
	}
}
#file {
	position: absolute;
	z-index: 2;
	font-size: 60px;
	opacity: 0;
	filter: alpha(opacity=0);
}
/* .xiu{
        width:73px;
        font-size:12px;
        text-align:center;
    } */
p {
	text-align: center;
	color: #ccc;
	margin-top: 20px;
}
.upload_box_i {
	border: 1px dashed #ccc;
	border-radius: 4px;
}
.upload_box {
	display: inline-block;
	width: 146px;
	height: 220px;
	// float: left;
	margin: 10px 10px 20px 10px;
}
.drag-container,
.option-item
{
	display: inline-block;
}
.option-item{
	margin: 10px 5px 0 5px;
}
/deep/.el-icon-plus {
	font-size: 75px !important;
	color: #ccc;
	margin-left: 35px;
	margin-top: 35px;
}
.upload_box_i {
	width: 146px;
	height: 220px;
}
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}
.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}
.deleteBtn{
	cursor: pointer;
}
.radio-optino{
	margin-left: 15px;
    margin-top: 10px;
    display: flex;
	.radio::after{
		content: "";
		display: inline-block;
		border: 1px solid #dcdfe6;
		border-radius: 100%;
		width: 14px;
		height: 14px;
		background-color: #fff;
		cursor: pointer;
		box-sizing: border-box;
		margin-top: 8px;
		margin-right: 3px;
	}
}
</style>
